/*
 * CLAB media — shared background-video behaviour.
 *
 * Every section that offers "image or video" renders through
 * snippets/media.liquid, which emits <video data-clab-video>. This file is the
 * one place that makes those actually play, so the behaviour cannot drift
 * between the hero, the drops, the megamenu tiles and the footer band.
 *
 * Three things the markup alone does not get right:
 *   1. Safari only reliably honours `muted` when it is set as a PROPERTY. The
 *      attribute alone stops working once the theme editor re-renders a
 *      section, which is exactly when a merchant is looking at it.
 *   2. A browser may still refuse the first play(). Swallow the rejection and
 *      let the poster stand in, rather than throwing into the console.
 *   3. A video that has scrolled away keeps decoding frames for nothing.
 */
(function () {
  'use strict';

  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)');

  function play(v) {
    var p = v.play();
    if (p && p.catch) p.catch(function () { /* blocked: the poster stands in */ });
  }

  function bind(v) {
    if (v.__clabBound) return;
    v.__clabBound = true;

    if (v.dataset.muted !== 'false') v.muted = true;
    if (v.dataset.loop !== 'false') v.loop = true;

    if (v.dataset.autoplay !== 'true') return;

    if (reduced.matches) { v.removeAttribute('autoplay'); v.pause(); return; }

    if (v.readyState >= 2) play(v);
    else v.addEventListener('loadeddata', function () { play(v); }, { once: true });

    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) play(v); else v.pause();
        });
      }, { threshold: 0 }).observe(v);
    }
  }

  function scan(root) {
    (root || document).querySelectorAll('video[data-clab-video]').forEach(bind);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { scan(); });
  } else {
    scan();
  }

  /* The theme editor swaps section markup without a page load. */
  document.addEventListener('shopify:section:load', function (e) { scan(e.target); });

  /* Hover-revealed panels (megamenu tiles) mount their video lazily. */
  document.addEventListener('clab:media-mounted', function (e) { scan(e.target); });
})();
